<template>
  <div>
    <v-card flat class="mt-3">
      <v-card-text>
        <v-progress-linear indeterminate v-if="carregando"></v-progress-linear>
        <template v-else>
          <v-btn rounded color="info" :to="{ name: 'enviar-documento' }">
            <v-icon size="18" class="mr-2">mdi-upload</v-icon>Enviar
            Documento</v-btn
          ><atualizar-atestados />
          <v-alert if="documentos.length == 0" type="info" class="mt-2" text>
            Nenhum documento encontrado
          </v-alert>
            <listar-atestados v-if="atestados.length > 0" />
        </template>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import AtualizarAtestados from "../../atestados/listar-atestados/components/AtualizarAtestados.vue";
import ListarAtestados from "../../atestados/listar-atestados/ListarAtestados.vue";
export default {
  components: {
    ListarAtestados,
    AtualizarAtestados,
  },
  computed: mapState("atestado", ["minHeight", "atestados"]),
  data: () => ({
    carregando: false,
  }),
  methods: {
    ...mapActions("atestado", ["getAtestados", "getStatus"]),
    ...mapMutations("atestado", ["setDados", "setNrDias"]),
  },
  async mounted() {
    this.carregando = true;
    this.setDados("OUTROS DOCUMENTOS");
    this.setNrDias(0);
    await this.getAtestados();
    await this.getStatus();
    this.carregando = false;
  },
};
</script>

